// extracted by mini-css-extract-plugin
export default {"root":"Backdrop-root-47982d20736dba7fc685e613781b425f","active":"Backdrop-active-7c744ae718f57822e32b40311ae75290"};